import React from 'react';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import { PostHogProvider } from 'posthog-js/react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import './App.scss';

import { App } from './App';
import { AuthPersist } from './components/pages/Login/auth-persist';
import { APP_NAME, FAVICON } from './constants';
import { posthogClient } from './helpers/posthog.helper';
import store from './store';

document.querySelector<HTMLLinkElement>('link[rel="icon"]')?.setAttribute('href', FAVICON);
document.title = APP_NAME;

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PostHogProvider client={posthogClient}>
          <AuthPersist>
            <ConfigProvider locale={enUS}>
              <App />
            </ConfigProvider>
          </AuthPersist>
        </PostHogProvider>
      </Provider>
    </React.StrictMode>,
  );
}
